<div fxLayout="row">
    <div *ngIf="userConfig.profileValue('CNService','encode')" fxFlex="300px" class="contact-services-panel">
        <div style="min-height:150px;max-height:150px;">
            <app-contact-services [codes]="contact.contactService?.serviceCodes" [mode]="servicesMode" (action)="codeAction($event)" class="contact-services"></app-contact-services>
        </div>
        <div *ngIf="!contact?.isPaid" class="contact-services-services">
            <app-contact-services-panel (action)="codeAction($event)"></app-contact-services-panel>
        </div>
    </div>
    <div fxFlex="grow">
        <ng-template #contactContainer></ng-template>
    </div>
</div>
